// Use vuex
import Vue from 'vue';
import Vuex from 'vuex';

// Import vuex modules
import cart from './modules/cart';
import checkout from './modules/checkout/index';
import checkoutV3 from './modules/checkout-v3/index';
import responsive from './modules/responsive/index';

Vue.use(Vuex);

const store = new Vuex.Store({
	modules: {
		cart,
		checkout,
		checkoutV3,
		responsive,
	},
});

export default store;
